import { Card, CardContent, Grid, Typography, Box, Paper, Stack, Chip, LinearProgress, Alert } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { gql, useQuery } from '@apollo/client';
import LeadGenDataTable from 'Components/LeadGenDataTable';
import MainCard from 'ui-component/cards/MainCard';
import { People as PeopleIcon, QrCodeScanner as QrCodeIcon } from '@mui/icons-material';

const FETCH_SCAN_DATA_BY_ID = gql`
    query FetchScanDataById($eventId: String!, $id: String!) {
        fetchScanDataById(eventId: $eventId, id: $id)
    }
`;

const GET_STAND_DETAILS = gql`
    query GetStandDetails($eventId: String!, $standId: String!) {
        standsByEventId(eventId: $eventId)
    }
`;

export default function LeadGenStaffCard() {
    const navigate = useNavigate();
    const { exhibitorId, eventId, staffId } = useParams();

    const { loading, error, data } = useQuery(FETCH_SCAN_DATA_BY_ID, {
        variables: { eventId, id: staffId },
    });

    const { data: standsData } = useQuery(GET_STAND_DETAILS, {
        variables: { eventId },
    });

    // Find staff member from stands data
    let staffMember = null;
    if (standsData?.standsByEventId) {
        try {
            const stands = JSON.parse(standsData.standsByEventId);
            for (const stand of stands) {
                if (stand.staff) {
                    staffMember = stand.staff.find(s => s.id === staffId);
                    if (staffMember) break;
                }
            }
        } catch (e) {
            console.error('Error parsing stands data:', e);
        }
    }

    const scanData = (data && data?.fetchScanDataById && JSON.parse(data?.fetchScanDataById)) || [];
    const totalScans = scanData?.length || 0;

    if (loading) {
        return (
            <MainCard title='Staff Details'>
                <LinearProgress />
            </MainCard>
        );
    }

    if (error) {
        return (
            <MainCard title='Staff Details'>
                <Alert severity='error'>{error.message}</Alert>
            </MainCard>
        );
    }

    return (
        <MainCard title={staffMember?.name || 'Staff Lead Generation Data'}>
            <Stack spacing={3}>
                {/* Staff Summary */}
                {staffMember && (
                    <Paper
                        elevation={0}
                        sx={{
                            p: 3,
                            bgcolor: 'rgba(102, 126, 234, 0.08)',
                            border: '1px solid',
                            borderColor: 'rgba(102, 126, 234, 0.2)',
                            borderRadius: 2,
                        }}
                    >
                        <Stack direction='row' spacing={3} alignItems='center' flexWrap='wrap'>
                            <Box>
                                <Typography
                                    variant='caption'
                                    color='text.secondary'
                                    sx={{ textTransform: 'uppercase', letterSpacing: 1 }}
                                >
                                    Staff Name
                                </Typography>
                                <Typography variant='h6' fontWeight={700} sx={{ mt: 0.5 }}>
                                    {staffMember.name}
                                </Typography>
                            </Box>
                            <Box>
                                <Chip
                                    icon={<QrCodeIcon />}
                                    label={`${totalScans} Total Scans`}
                                    color='success'
                                    variant='outlined'
                                />
                            </Box>
                        </Stack>
                    </Paper>
                )}

                {/* Data Table */}
                <Box>
                    <Typography variant='h6' gutterBottom sx={{ mb: 2, fontWeight: 600 }}>
                        Lead Generation Data
                    </Typography>
                    <LeadGenDataTable type='attendee' id={staffId} />
                </Box>
            </Stack>
        </MainCard>
    );
}
